function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 12a1 1 0 0 0-1 1 1 1 0 0 0 1 1h16a1 1 0 0 0 1-1 1 1 0 0 0-1-1zM1 6a1 1 0 0 0-1 1 1 1 0 0 0 1 1h16a1 1 0 0 0 1-1 1 1 0 0 0-1-1ZM1 0a1 1 0 0 0-1 1 1 1 0 0 0 1 1h16a1 1 0 0 0 1-1 1 1 0 0 0-1-1Z",
    style: {
      color: "#000",
      fill: "#000"
    }
  }));
};
export default SvgHamburgerMenu;